'use es6';

import { createSelector } from 'reselect';
import { getFileUploadListForCurrentThreadId } from '../../file-uploads/selectors/getFileUploadListForCurrentThreadId';
import { hasUnansweredQuickReplyMessage as hasUnansweredQuickReplyMessageSelector } from '../../selectors/chatSelectors';
import { getAllowUserInput } from '../../thread-histories/selectors/getAllowUserInput';
import { getShouldDisableAttachments } from '../../widget-ui/selectors/getShouldDisableAttachments';
export const canUploadAttachments = createSelector([getAllowUserInput, getFileUploadListForCurrentThreadId, hasUnansweredQuickReplyMessageSelector, getShouldDisableAttachments], (allowUserInput, uploadList, hasUnansweredQuickReplyMessage, shouldHideAttachments) => {
  if (!allowUserInput && hasUnansweredQuickReplyMessage || shouldHideAttachments) {
    return false;
  } else if (!uploadList) {
    return true;
  }
  return !uploadList.size;
});